import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { zIndex, layout } from '../../styles/theme';
import { AUTH_PANEL_INSET, authPanelWrapperSx } from '../styles/authPanel.styles';

const AuthLayout = () => (
  <Box
    sx={{
      position: 'absolute',
      top: `${layout.mapHeaderHeight}px`,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: { xs: 'center', sm: 'flex-end' },
      px: AUTH_PANEL_INSET,
      py: AUTH_PANEL_INSET,
      pointerEvents: 'none',
      boxSizing: 'border-box',
      zIndex: zIndex.card,
    }}
  >
    <Box
      sx={{
        ...authPanelWrapperSx,
        pointerEvents: 'auto',
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default AuthLayout;
